var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { useReducer } from 'react';
import { FormControlLabel, Grid } from '@material-ui/core';
import styled from 'styled-components';
import { Box, Button, Checkbox, Paper, TextField, Typography, } from '@kareo/design-system';
import validateCardholderName from '../validateCardholderName';
import validateZipcode from '../validateZipcode';
import states from '../../StateSelect/states';
var BILLING_STATES = __spreadArrays(states, [
    { name: 'American Samoa', code: 'AS' },
    { name: 'Armed Forces Americas', code: 'AA' },
    { name: 'Armed Forces Europe', code: 'AE' },
    { name: 'Armed Forces Pacific', code: 'AP' },
    { name: 'Federated States of Micronesia', code: 'FM' },
    { name: 'Guam', code: 'GU' },
    { name: 'Marshall Islands', code: 'MH' },
    { name: 'Northern Mariana Islands', code: 'MP' },
    { name: 'Palau', code: 'PW' },
    { name: 'Puerto Rico', code: 'PR' },
    { name: 'U.S. Virgin Islands', code: 'VI' },
]).sort(function (first, second) { return first.name.localeCompare(second.name); });
function getHelperTextDefault(_a) {
    var errorText = _a.errorText, showError = _a.showError, value = _a.value;
    if (!showError) {
        return undefined;
    }
    if (value.length === 0) {
        return 'Required';
    }
    return errorText;
}
var StyledTextField = styled(TextField)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  && input.MuiInputBase-input,\n  && select.MuiInputBase-input {\n    border: 0;\n    box-shadow: none;\n    margin: 0;\n    padding-bottom: 10.5px;\n    padding-top: 10.5px;\n  }\n\n  && input.MuiInputBase-input:focus,\n  && select.MuiInputBase-input:focus {\n    box-shadow: none;\n  }\n\n  && select.MuiInputBase-input {\n    box-sizing: border-box;\n    height: 40px;\n    padding-left: 7px;\n    padding-right: 32px;\n  }\n\n  && fieldset.MuiOutlinedInput-notchedOutline {\n    border-style: solid;\n    border-width: 1px;\n    margin: 0;\n    padding: 0 8px;\n  }\n"], ["\n  && input.MuiInputBase-input,\n  && select.MuiInputBase-input {\n    border: 0;\n    box-shadow: none;\n    margin: 0;\n    padding-bottom: 10.5px;\n    padding-top: 10.5px;\n  }\n\n  && input.MuiInputBase-input:focus,\n  && select.MuiInputBase-input:focus {\n    box-shadow: none;\n  }\n\n  && select.MuiInputBase-input {\n    box-sizing: border-box;\n    height: 40px;\n    padding-left: 7px;\n    padding-right: 32px;\n  }\n\n  && fieldset.MuiOutlinedInput-notchedOutline {\n    border-style: solid;\n    border-width: 1px;\n    margin: 0;\n    padding: 0 8px;\n  }\n"])));
export function FormTextField(props) {
    return React.createElement(StyledTextField, __assign({ fullWidth: true, size: "small", margin: "none" }, props));
}
export function FormStateSelect(props) {
    var hasExistingValue = props.value && !BILLING_STATES.some(function (state) { return state.code === props.value; });
    return (React.createElement(FormTextField, __assign({}, props, { select: true, SelectProps: { native: true }, InputLabelProps: { shrink: true } }),
        React.createElement("option", { value: "" }, "Select State"),
        hasExistingValue && React.createElement("option", { value: props.value }, props.value),
        BILLING_STATES.map(function (state) { return (React.createElement("option", { key: state.code, value: state.code }, state.name)); })));
}
export default function NewCardForm(props) {
    var _a, _b, _c, _d, _e, _f, _g;
    var formState = props.formState, setFormState = props.setFormState, _h = props.onSubmit, onSubmit = _h === void 0 ? function () { } : _h, _j = props.getHelperText, getHelperText = _j === void 0 ? getHelperTextDefault : _j, _k = props.config, config = _k === void 0 ? {
        showComments: true,
        showNickname: true,
    } : _k, onCancel = props.onCancel, patientAddress = props.patientAddress;
    // this state determines if we are showing errors, not what the errors are
    var _l = useReducer(function (state, changes) {
        return __assign(__assign({}, state), changes);
    }, {
        showNameError: false,
        showZipError: false,
    }), errors = _l[0], setErrors = _l[1];
    var requireBillingZip = (_a = config.requireBillingZip) !== null && _a !== void 0 ? _a : true;
    var showFullBillingAddress = (_b = config.showFullBillingAddress) !== null && _b !== void 0 ? _b : false;
    var hasValidForm = validateCardholderName(formState.cardholderName) &&
        (requireBillingZip
            ? validateZipcode(formState.zipCode)
            : !formState.zipCode || validateZipcode(formState.zipCode));
    var commentsLength = (_d = (_c = formState.comments) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0;
    function onSubmitBaseForm(evt) {
        evt.preventDefault();
        if (!hasValidForm)
            return;
        onSubmit(formState);
    }
    function onChangeForm(evt) {
        var _a = evt.target, checked = _a.checked, name = _a.name, type = _a.type, value = _a.value;
        setFormState(function (currentFormState) {
            var _a;
            return (__assign(__assign({}, currentFormState), (_a = {}, _a[name] = type === 'checkbox' ? checked : value, _a)));
        });
    }
    function onUsePatientAddressChange(evt) {
        var checked = evt.target.checked;
        setFormState(function (currentFormState) {
            var _a, _b, _c, _d;
            return (__assign(__assign(__assign({}, currentFormState), (checked && {
                billingAddress1: (_a = patientAddress === null || patientAddress === void 0 ? void 0 : patientAddress.address1) !== null && _a !== void 0 ? _a : '',
                billingCity: (_b = patientAddress === null || patientAddress === void 0 ? void 0 : patientAddress.addressCity) !== null && _b !== void 0 ? _b : '',
                billingState: (_c = patientAddress === null || patientAddress === void 0 ? void 0 : patientAddress.addressState) !== null && _c !== void 0 ? _c : '',
                zipCode: (_d = patientAddress === null || patientAddress === void 0 ? void 0 : patientAddress.addressZipcode) !== null && _d !== void 0 ? _d : '',
            })), { usePatientAddress: checked }));
        });
    }
    var zipCodeField = (React.createElement(Grid, { item: true, xs: 6 },
        React.createElement(FormTextField, { id: "billing-zip-code", name: "zipCode", value: formState.zipCode, label: showFullBillingAddress ? 'Zip Code' : 'Billing Zip Code', disabled: !showFullBillingAddress && formState.usePatientAddress, error: errors.showZipError, helperText: showFullBillingAddress
                ? errors.showZipError
                    ? 'Enter a five-digit ZIP or ZIP+4'
                    : undefined
                : getHelperText({
                    errorText: 'Invalid',
                    showError: errors.showZipError,
                    value: formState.zipCode,
                }), onChange: onChangeForm, onBlur: function () {
                setErrors({
                    showZipError: (requireBillingZip || Boolean(formState.zipCode)) &&
                        !validateZipcode(formState.zipCode),
                });
            } })));
    var patientAddressCheckbox = config.showUsePatientAddress && (React.createElement(Grid, { item: true, xs: 12 },
        React.createElement(FormControlLabel, { control: React.createElement(Checkbox, { checked: Boolean(formState.usePatientAddress), disabled: !(patientAddress === null || patientAddress === void 0 ? void 0 : patientAddress.addressZipcode), onChange: onUsePatientAddressChange }), label: showFullBillingAddress
                ? 'Billing Address is same as patient address'
                : "Use patient's address as billing address" })));
    return (React.createElement(Paper, { variant: "outlined" },
        React.createElement(Box, { padding: 2 },
            React.createElement(Box, { component: "form", onSubmit: onSubmitBaseForm },
                React.createElement(Box, { alignItems: "center", display: "flex", justifyContent: "space-between", marginBottom: 2 },
                    React.createElement(Typography, { variant: "h4" }, "Add a Card"),
                    config.showMakeDefaultCard && (React.createElement(FormControlLabel, { control: React.createElement(Checkbox, { checked: Boolean(formState.makeDefaultCard), disabled: config.disableMakeDefaultCard, onChange: function (event) {
                                var checked = event.target.checked;
                                setFormState(function (currentFormState) { return (__assign(__assign({}, currentFormState), { makeDefaultCard: checked })); });
                            } }), label: "Make this my default card", style: { marginRight: 0 } }))),
                React.createElement(Grid, { container: true, spacing: 1 },
                    React.createElement(Grid, { item: true, xs: 6 },
                        React.createElement(FormTextField, { id: "cardholder-name", name: "cardholderName", value: formState.cardholderName, label: "Cardholder Name", required: true, placeholder: "Enter cardholder name", autoComplete: "cc-name", error: errors.showNameError, helperText: getHelperText({
                                errorText: 'Invalid Characters',
                                showError: errors.showNameError,
                                value: formState.cardholderName,
                            }), onChange: onChangeForm, onBlur: function () {
                                setErrors({
                                    showNameError: !validateCardholderName(formState.cardholderName),
                                });
                            } })),
                    !showFullBillingAddress && zipCodeField,
                    !showFullBillingAddress && patientAddressCheckbox,
                    config.showNickname && (React.createElement(Grid, { item: true, xs: 6 },
                        React.createElement(FormTextField, { id: "card-nickname", name: "nickname", value: formState.nickname, label: "Card Nickname", onChange: onChangeForm }))),
                    config.showComments && (React.createElement(Grid, { item: true, xs: 12, style: { marginBottom: -8 } },
                        React.createElement(FormTextField, { id: "practice-comments", name: "comments", value: formState.comments, label: "Comments for the practice", helperText: commentsLength + "/60", FormHelperTextProps: {
                                style: {
                                    marginLeft: 0,
                                    marginRight: 0,
                                    marginTop: 2,
                                    lineHeight: '16px',
                                    textAlign: 'right',
                                },
                            }, inputProps: { maxLength: 60 }, onChange: onChangeForm }))),
                    showFullBillingAddress && patientAddressCheckbox,
                    showFullBillingAddress && !formState.usePatientAddress && (React.createElement(React.Fragment, null,
                        React.createElement(Grid, { item: true, xs: 6 },
                            React.createElement(FormTextField, { id: "billing-address", name: "billingAddress1", value: (_e = formState.billingAddress1) !== null && _e !== void 0 ? _e : '', label: "Billing Address", onChange: onChangeForm })),
                        React.createElement(Grid, { item: true, xs: 6 },
                            React.createElement(FormTextField, { id: "billing-city", name: "billingCity", value: (_f = formState.billingCity) !== null && _f !== void 0 ? _f : '', label: "City", onChange: onChangeForm })),
                        React.createElement(Grid, { item: true, xs: 6 },
                            React.createElement(FormStateSelect, { id: "billing-state", name: "billingState", value: (_g = formState.billingState) !== null && _g !== void 0 ? _g : '', label: "State", onChange: onChangeForm })),
                        zipCodeField))),
                React.createElement(Box, { display: "flex", flexDirection: "row", justifyContent: "flex-end", marginTop: showFullBillingAddress ? 2 : 0 },
                    onCancel && (React.createElement(Box, { marginRight: 1 },
                        React.createElement(Button, { type: "button", variant: "text", onClick: onCancel }, "Cancel"))),
                    React.createElement(Box, null,
                        React.createElement(Button, { type: "submit", disabled: !hasValidForm, variant: "contained", color: "default" }, "Add Card Number")))))));
}
var templateObject_1;
